import React, { useEffect, useState } from "react";
import Player from "../player";
import Map from "../map";
import API from "../../utils/API";
import { useHistory, useParams } from "react-router-dom";
import MusicBtn from "../../components/SoundBtns/MusicBtn";
import { DragonCave } from "../../data/maps/1";
import store from "../../config/store";
import { resolveStageEntrySpawn, prepareConnectedTransition } from "../../config/worldTransitions";
import SleepingDragon from "./SleepingDragon";

function DragonCaveWorld(props) {
  const { id } = useParams();
  const history = useHistory();
  const [initialPosition] = useState(() => resolveStageEntrySpawn(id, "dragon-cave", props.initialPosition));

  useEffect(() => {
    store.dispatch({ type: "ADD_TILES", payload: { tiles: DragonCave } });
    API.UpdateSpritePlace("dragon-cave", id).catch(() => {});
  }, [id]);

  const leaveDragonCave = (position) => {
    const cell = [position[0] / 64, position[1] / 64];
    const transition = prepareConnectedTransition(id, "dragon-cave", "SOUTH", cell);
    if (!transition) return;
    API.UpdateSpritePlace(transition.destination, id)
      .finally(() => history.push(`/lake-bed/${id}`));
  };

  return (
    <div id="world-container" className="dragon-cave-world" style={{ position: "relative", width: "968px", top: "35%", marginLeft: "3px", border: "4px solid black", borderRadius: "5px" }}>
      <MusicBtn />
      <Map />
      <SleepingDragon />
      <Player avatar={props.avatar} avatarName={props.avatarName} initialPosition={initialPosition}
        exitZones={{ SOUTH: [[7, 14]] }} onRightEdge={leaveDragonCave} />
    </div>
  );
}

export default DragonCaveWorld;
